export const SHARING_FEATURE_FTUX_CUTOFF = '2020-06-30';
